import React, { useEffect, useState } from "react";
import {
  useWSModalCustom,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSProgressBar,
  WSText
} from "@wingspanhq/fe-component-library";
import { BulkActionReminder } from "../components/BulkActionReminder";
import { BulkActionProgressCard } from "../components/BulkActionProgressCard";
import { BulkActionProgress } from "../types";

type Props = {
  actionName: string;
  itemCount: number;
  process: (
    onProgress: (progress: BulkActionProgress) => void
  ) => Promise<BulkActionProgress>;
} & WSModalCustomProps<BulkActionProgress>;

const ModalForegroundProcessing: React.FC<Props> = props => {
  const [progress, setProgress] = useState<BulkActionProgress>({
    total: props.itemCount,
    processed: 0,
    successful: 0,
    failed: 0
  });

  useEffect(() => {
    let cancelled = false;

    props
      .process(nextProgress => {
        if (!cancelled) setProgress(nextProgress);
      })
      .then(result => {
        if (!cancelled) props.onClose(result);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const percent =
    progress.total > 0
      ? Math.round((progress.processed / progress.total) * 100)
      : 0;
  const remaining = progress.total - progress.processed;

  return (
    <WSModal title={props.actionName} blockClose onClose={props.onClose}>
      <WSList gap="M">
        <WSElement px="L">
          <WSList gap="M">
            <WSProgressBar percent={percent} theme="info" />

            <WSFlexBox.CenterY>
              <WSIcon name="loader" size="S" color="gray500" mr="S" />
              <WSText.ParagraphSm color="gray700">
                Processing {progress.processed.toLocaleString()} of{" "}
                {progress.total.toLocaleString()} items
                {remaining > 0 && ` (${remaining.toLocaleString()} remaining)`}
              </WSText.ParagraphSm>
            </WSFlexBox.CenterY>

            <BulkActionProgressCard progress={progress} />
          </WSList>
        </WSElement>

        <BulkActionReminder
          actionName={props.actionName}
          actionType="foreground"
        />
      </WSList>
    </WSModal>
  );
};

export const useModalForegroundProcessing = () =>
  useWSModalCustom(ModalForegroundProcessing);
